(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('comparationReportController', comparationReportController);

  /** @ngInject */
  function comparationReportController ($scope, $translate, reportExportUtil, exportToCsv, ComparationReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new ComparationReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('MONTHS'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.MONTH,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('COMPARE_PERIODS_REPORT'),
          true);
    }

  }
})();
